import React from "react";
import { useTranslation } from "react-i18next";
import { StyledAboutus } from "../components/Styles";
import Consultation from "../components/Consultation";
import LinkedinIcon from "../components/Icons/Linkedin";
import EmailIcon from "../components/Icons/Email";
import { Link } from "react-router-dom";

import About from "../components/Styles/assets/aboutus.webp";


const Aboutus = () => {
  const { i18n, t } = useTranslation();

  const teamMembers = t("aboutus.team.members", { returnObjects: true });

  return (
    <StyledAboutus.Container>
      <StyledAboutus.Content>
        <StyledAboutus.ShapeTopLeft lang={i18n.language}>
          <img src={About} alt={t("aboutus.alt")} />
        </StyledAboutus.ShapeTopLeft>

        <StyledAboutus.Title>
          <span>{t("aboutus.titleSpan")}</span>
          {t("aboutus.title")}
        </StyledAboutus.Title>

        <StyledAboutus.Description>
          {t("aboutus.description")}
        </StyledAboutus.Description>
      </StyledAboutus.Content>

      <StyledAboutus.H3>{t("aboutus.team.title")}</StyledAboutus.H3>

      <StyledAboutus.Team>
        {teamMembers.map((member, idx) => (
          <StyledAboutus.Member key={idx}>
            {member.imgWrapper ? (
              <div>
                <img src={`/${member.img}`} alt={member.name} />
              </div>
            ) : (
              <img src={`/${member.img}`} alt={member.name} />
            )}

            <div className="papper">
              <p>{member.name}</p>
              <p>{member.position}</p>
              <div className="social">
                {member.linkedin && (
                  <Link to={member.linkedin} target="_blank">
                    <LinkedinIcon width={24} height={24} />
                  </Link>
                )}
                {member.email && (
                  <a
                    href={`mailto:${member.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <EmailIcon width={24} height={24} />
                  </a>
                )}
              </div>
            </div>
          </StyledAboutus.Member>
        ))}
      </StyledAboutus.Team>

      <Consultation />
    </StyledAboutus.Container>
  );
};

export default Aboutus;